import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  IsecureFileUpload,
  ISecureUploadSlice,
  IsecureUploadList,
} from './types';

const initialState: ISecureUploadSlice = {
  userId: '',
  fileUploadEnabled: false,
  updatedAt: '',
  filesList: [],
};

const secureUploadSlice = createSlice({
  name: 'secureUpload',
  initialState,
  reducers: (create) => ({
    setUploadEnabled: create.reducer(
      (state, action: PayloadAction<IsecureFileUpload>) => {
        const { userId, fileUploadEnabled, updatedAt } = action.payload;
        state.userId = userId;
        state.fileUploadEnabled = fileUploadEnabled;
        state.updatedAt = updatedAt;
      },
    ),
    setUserFiles: create.reducer(
      (state, action: PayloadAction<IsecureUploadList[]>) => {
        state.filesList = action.payload;
      },
    ),
    setFileDelete: create.reducer((state, action: PayloadAction<string>) => {
      state.filesList = state.filesList.filter(
        (item) => item.id !== action.payload,
      );
    }),
  }),
  selectors: {
    getuploadEnabled: (secureUpload) => secureUpload.fileUploadEnabled,
    getUserFilesList: (secureUpload) => secureUpload.filesList,
  },
});

export const { setUploadEnabled, setUserFiles, setFileDelete } =
  secureUploadSlice.actions;
export const { getuploadEnabled, getUserFilesList } =
  secureUploadSlice.selectors;

export default secureUploadSlice.reducer;
